import { BrowserUtils } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import React, { FC, useEffect } from 'react'
import { requestScopes } from '../services/AuthConfig'

const Logout: FC = () => {
  const { instance } = useMsal()
  useEffect(() => {
    instance
      .acquireTokenSilent({ scopes: requestScopes, account: instance.getActiveAccount() ?? undefined })
      .then(({ idToken }) => {
        instance.logoutRedirect({
          idTokenHint: idToken,
          account: instance.getActiveAccount(),
          onRedirectNavigate: () => !BrowserUtils.isInIframe(),
        })
      })
  }, [instance])
  return <div>Logout</div>
}

export default Logout
